const AlertBanner = ({ unreadAlerts, handleTabClick }) => {

  if (unreadAlerts === 0) return null;

  return (
    <div
      className="bg-blue-50 border-blue-500 hover:bg-blue-100 dark:bg-blue-900/20 dark:border-blue-400 dark:hover:bg-blue-900/30 border-l-4 p-4 rounded-none cursor-pointer transition-colors"
      onClick={() => handleTabClick('alerts')}
    >
      <div className="flex justify-between items-center">
        <div>
          <h3 className="font-semibold text-blue-800 dark:text-blue-200">
            Você tem {unreadAlerts} alerta(s) não lido(s)
          </h3>
          <p className="text-sm text-blue-600 dark:text-blue-300">
            Clique aqui para visualizar
          </p>
        </div>
        <span className="bg-blue-500 text-white text-xs font-bold rounded-full h-6 w-6 flex items-center justify-center">
          {unreadAlerts}
        </span>
      </div>
    </div>
  );
};

export default AlertBanner;